<script setup lang="ts">
import PremiumInvoiceDialog from '@/components/asicw/premium-invoices/PremiumInvoiceDialog.vue'
import PremiumInvoicesTable from '@/components/asicw/tables/PremiumInvoicesTable.vue'
import { useOIDCStore } from '@/stores/oidc.store'
import ViewLayout from '@/views/layouts/ViewLayout.vue'
import { Plus } from '@element-plus/icons-vue'
import { ref } from 'vue'

const { isASICWManagerUser } = useOIDCStore()

const createPremiumInvoiceDialogOpen = ref<boolean>(false)

const handleCreatePremiumInvoices = () => {
  createPremiumInvoiceDialogOpen.value = true
}
</script>

<template>
  <ViewLayout>
    <PremiumInvoicesTable />
    <template #controls>
      <el-button v-if="isASICWManagerUser" type="primary" :icon="Plus" @click="handleCreatePremiumInvoices"
        >Create Premium Invoice</el-button
      >
    </template>

    <PremiumInvoiceDialog v-if="createPremiumInvoiceDialogOpen" v-model="createPremiumInvoiceDialogOpen" />
  </ViewLayout>
</template>
